export default async (args = {}) => {
  return `<address class="mb-2">
  Nós ficamos localizados na <strong>${site.end}</strong>
  </address>
  <div class="v-responsive">
    <div class="v-responsive__sizer" style="padding-bottom: 56.25%;"></div>
    <div class="v-responsive__content">
      <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3657.065830119029!2d${site.lng}!3d${site.lat}!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94ce59c8da0aa315%3A0xd59f9431f2c9776a!2s${site.name}!5e0!3m2!1spt-BR!2sbr!4v1557500795710!5m2!1spt-BR!2sbr" width="100%" height="100%" frameborder="0" style="border:0" allowfullscreen></iframe>
    </div>
  </div>`
}